import React from 'react';

/**
 * AppStatus Component
 * Displays key metadata about the application, including its purpose,
 * current version, and last updated time.
 * This component is self-contained and uses Tailwind CSS for styling.
 */
const AppStatus = () => {
    // Define application metadata
    const appInfo = {
        name: "OneCRM",
        purpose: "we just automate everything.",
        version: "1.0.0",
        // Use a standard date format to show the last update time
       
    };

    return (
        <div className="flex justify-center items-center p-4 sm:p-6 bg-gray-50 min-h-screen font-inter">
            <div className="max-w-xl w-full bg-white p-6 sm:p-8 rounded-2xl shadow-xl border border-gray-100 transition duration-300 hover:shadow-2xl">
                
                {/* Header */}
                <h1 className="text-3xl font-extrabold text-center text-black mb-6 border-b-2 pb-3 border-yellow-400">
                    {appInfo.name} Status
                </h1>

                <div className="space-y-6">
                    {/* Purpose Section */}
                    <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-600 shadow-inner">
                        <h2 className="text-xl font-semibold text-blue-800 mb-2 flex items-center">
                            {/* Icon for Purpose */}
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                            Application Purpose
                        </h2>
                        <p className="text-gray-700 leading-relaxed text-sm">
                            {appInfo.purpose}
                        </p>
                    </div>

                    {/* Version and Update Section */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {/* Version Card */}
                        <div className="bg-green-50 p-4 rounded-lg border-t-2 border-green-400 shadow-sm">
                            <h3 className="text-sm font-medium text-gray-500 mb-1 uppercase tracking-wider">Current Version</h3>
                            <p className="text-2xl font-bold text-green-700">{appInfo.version}</p>
                        </div>

                        {/* Last Updated Card */}
                        <div className="bg-yellow-50 p-4 rounded-lg border-t-2 border-yellow-400 shadow-sm">
                            <h3 className="text-sm font-medium text-gray-500 mb-1 uppercase tracking-wider">Last Updated</h3>
                            <p className="text-base font-medium text-gray-800">06-10-2025</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AppStatus;
